import { useController, useFormContext } from "react-hook-form";
import { CalendarPickerRangeRhfProps } from "./CalendarPicker";
import CalendarPickerComponent from "./CalendarPickerComponent";

export default function CalendarPickerRangeRhf(
  props: CalendarPickerRangeRhfProps
) {
  const {
    name: [startDate, endDate],
    ...rest
  } = props;

  const { control } = useFormContext();
  const {
    field: { value: startValue, onChange: onStartChange },
  } = useController({ control, name: startDate });

  const {
    field: { value: endValue, onChange: onEndChange },
  } = useController({ control, name: endDate });

  const onChange = (value: [Date, Date | undefined]) => {
    onStartChange(value[0]);
    /*
      useController onChange does not accept undefined, so we use null
      https://react-hook-form.com/docs/usecontroller 
    */
    onEndChange(value[1] ?? null);
    props.onChange?.(); // Call the onChange prop if provided
  };

  return (
    <CalendarPickerComponent
      {...rest}
      onChange={onChange}
      value={[startValue, endValue ?? undefined]}
    />
  );
}
